// src/components/StatesWeServe.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StatesWeServe.css';

const StatesWeServe = () => {
  const navigate = useNavigate();

  // All US States grouped
  const statesGroup1 = [
    'ILLINOIS', 'NEW JERSEY', 'CONNECTICUT', 'PENNSYLVANIA',
    'MASSACHUSETTS', 'TEXAS', 'NEW YORK', 'MICHIGAN',
    'ARIZONA', 'INDIANA', 'CALIFORNIA', 'OHIO',
    'MINNESOTA', 'FLORIDA', 'GEORGIA', 'WASHINGTON',
    'SOUTH CAROLINA', 'NORTH CAROLINA', 'TENNESSEE', 'COLORADO','ALABAMA', 'ALASKA', 'ARKANSAS', 'DELAWARE',
    'OREGON', 'VIRGINIA', 'WEST VIRGINIA', 'KANSAS',
    'MAINE', 'MARYLAND', 'MISSISSIPPI', 'LOUISIANA',
    'MISSOURI', 'MONTANA', 'VERMONT', 'KENTUCKY', 'NEW HAMPSHIRE', 'NEW MEXICO', 'NORTH DAKOTA', 'OKLAHOMA',
    'HAWAII', 'RHODE ISLAND', 'SOUTH DAKOTA', 'UTAH',
    'IDAHO', 'IOWA', 'WISCONSIN', 'WYOMING',
    'NEBRASKA', 'NEVADA'
  ];

 

 

  // Function to handle state click
 const handleStateClick = (stateName) => {
  const stateRoute = stateName.toLowerCase().replace(/\s+/g, '-');
  navigate(`/states/${stateRoute}`);
};

  return (
    <main className="states-page">
      {/* Hero Section */}
      {/* Hero Section */}
<section className="states-hero">
  <div className="container">
    <div className="states-hero-content">
      <h1 className="states-hero-title">
        Find Medical Billing Services <span className="highlight">Near You — Explore by State</span>
      </h1>
      <p className="states-hero-description">
        Providers Care Billing LLC is transforming the medical billing industry and continuously evolving to meet the 
        future needs of healthcare practices. We proudly serve physicians and providers in all states across the USA 
        with unmatched billing and credentialing expertise.
      </p>
      <div className="hero-quote">
        <p className="quote-text">
          "Our commitment is simple: Helping Practices Maximize Revenue while focusing on quality Patient Care."
        </p>
      </div>
    </div>
  </div>
</section>

      {/* States Grid Section */}
      <section className="states-grid-section">
        <div className="container">
          <h2 className="states-section-title">States We Serve</h2>
          
          <div className="states-grid">
            {statesGroup1.map((state, index) => (
              <div 
                className="state-card" 
                key={index}
                onClick={() => handleStateClick(state)}
              >
                <span className="state-name">{state}</span>
              </div>
            ))}
          </div>

        

          
        </div>
      </section>

      {/* Contact Section */}
      <section className="states-contact">
        <div className="container">
          <div className="contact-content">
            <h2 className="contact-title">Contact Us for Complete Revenue Cycle Management</h2>
            <div className="contact-phone">
              <span className="phone-icon">📞</span>
              <span className="phone-number">Contact Providers Care Billing LLC today at <strong>888-495-3786</strong> for your consultation.</span>
            </div>
            <p className="contact-description">
              Partnering with us brings multiple advantages - we help you boost your cash flow, improve patient collections, 
              and streamline your entire billing process. Our dedicated team is more than just a billing company - we become 
              an extension of your practice.
            </p>
            <p className="contact-cta-text">
              Get in touch with us today to discover how we can support your success.
            </p>
            <button className="book-appointment-btn">Book Your Appointment Now! →</button>
          </div>
        </div>
      </section>

      {/* Trust Badges Section */}
      <section className="states-badges">
        <div className="container">
          <div className="badges-wrapper-states">
            {/* <div className="badge-item-states">
              <div className="badge-rating">4.8 ⭐⭐⭐⭐⭐</div> 
              <div className="badge-label">Google Rating</div>
            </div> */}
            <div className="badge-item-states">
              <div className="badge-icon">✓</div>
              <div className="badge-label">ACCREDITED BUSINESS</div>
            </div>
            <div className="badge-item-states">
              <div className="badge-icon">🔒</div>
              <div className="badge-label">HIPAA COMPLIANT</div>
            </div>
            <div className="badge-item-states">
              <div className="badge-icon">⚖️</div>
              <div className="badge-label">DMCA PROTECTED</div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default StatesWeServe;